import { render, staticRenderFns } from "./RequiredErrorMessage.vue?vue&type=template&id=bf6df0e0&"
import script from "./RequiredErrorMessage.vue?vue&type=script&lang=js&"
export * from "./RequiredErrorMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("n:\\Data\\Projects\\Werk\\DPG\\DNX2-DPG\\MarketingDb.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bf6df0e0')) {
      api.createRecord('bf6df0e0', component.options)
    } else {
      api.reload('bf6df0e0', component.options)
    }
    module.hot.accept("./RequiredErrorMessage.vue?vue&type=template&id=bf6df0e0&", function () {
      api.rerender('bf6df0e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Components/Errors/RequiredErrorMessage.vue"
export default component.exports